<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="a"
                :pages="[
                    {
                        name: $tc('messages.practice_races', 2),
                        href: meta.links.index,
                    },
                    {
                        name: $t('messages.create'),
                        href: null,
                    },
                ]"
            />
        </template>

        <form :action="meta.links.update" method="post" @submit.prevent="submit">
            <TitleFieldsFormSection>
                <template v-slot:title>
                    {{ $t('messages.information') }}
                </template>
                <div class="md:grid md:grid-cols-12 md:gap-6">
                    <div class="sm:col-span-6">
                        <div class="mt-1">
                            <FormLabel :value="$t('messages.name')" for="name" />
                            <FormInput
                                id="name"
                                v-model="form.name"
                                name="name"
                                type="text"
                                max="191"
                                class="mt-1 w-full"
                                :placeholder="$t('messages.(optional)')"
                            />
                            <FormError :value="form.errors.name" class="mt-2" />
                        </div>
                    </div>

                    <div class="sm:col-span-6">
                        <div class="mt-1">
                            <FormLabel :value="$t('messages.description')" for="description" />
                            <FormInput
                                id="description"
                                v-model="form.description"
                                name="description"
                                type="text"
                                class="mt-1 w-full"
                                :placeholder="$t('messages.(optional)')"
                            />
                            <FormError :value="form.errors.description" class="mt-2" />
                        </div>
                    </div>

                    <div class="sm:col-span-6">
                        <div class="mt-1">
                            <FormLabel :value="$t('messages.goal')" for="goal" />
                            <FormInput required id="goal" v-model="form.goal" name="goal" type="text" class="mt-1" />
                            <FormError :value="form.errors.goal" class="mt-2" />
                        </div>
                    </div>

                    <div class="sm:col-span-6">
                        <div class="mt-1">
                            <FormLabel :value="$t('messages.level_required')" for="level_required">
                                ({{ $t('messages.min') }})
                            </FormLabel>
                            <FormQuestionLevelDifficultyInput
                                v-model.number="form.level_required"
                                name="level_required"
                                :max="5"
                            />
                            <FormError :value="form.errors.level_required" class="mt-2" />
                        </div>
                    </div>
                </div>
            </TitleFieldsFormSection>
            <TitleFieldsFormSection>
                <template v-slot:title>
                    {{ $t('messages.subject', 2) }}
                </template>
                <div class="">
                    <div v-for="subject in options.subjects" :key="subject.id" class="mt-5">
                        <div>
                            {{ subject.text }}
                        </div>
                        <AppWell class="mt-3">
                            <AppCard>
                                <div class="mt-3 flex gap-2 flex-wrap">
                                    <label v-for="tag in subject.tags" :key="tag.id">
                                        <BadgePill :color="form.tag_ids.includes(tag.id) ? 'indigo' : 'gray'">
                                            <input
                                                type="checkbox"
                                                name="tag_ids[]"
                                                :id="tag.id"
                                                v-model="form.tag_ids"
                                                :value="tag.id"
                                                class="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded"
                                            />
                                            <span class="ml-1">{{ tag.name }}</span>
                                        </BadgePill>
                                    </label>
                                </div>
                            </AppCard>
                        </AppWell>
                    </div>
                </div>
            </TitleFieldsFormSection>

            <div class="flex justify-end mt-5">
                <SubmitFormButton :button-text="$t('messages.save')" :processing="form.processing" />
            </div>
        </form>
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import TitleFieldsFormSection from '@/components/TitleFieldsFormSection.vue';
import FormInput from '@/components/Forms/FormInput.vue';
import FormLabel from '@/components/Forms/FormLabel.vue';
import FormError from '@/components/Forms/FormError.vue';
import SubmitFormButton from '@/Pages/Teacher/Activities/Subactivities/SubmitFormButton.vue';
import AppCard from '@/Shared/AppCard.vue';
import BadgePill from '@/components/BadgePill.vue';
import AppWell from '@/Shared/AppWell.vue';
import FormQuestionLevelDifficultyInput from '@/components/Forms/FormQuestionLevelDifficultyInput.vue';

export default {
    components: {
        AppWell,
        BadgePill,
        AppCard,
        SubmitFormButton,
        PanelPage,
        TitleFieldsFormSection,
        FormInput,
        FormLabel,
        FormError,
        FormQuestionLevelDifficultyInput,
    },
    layout: Layout,
    name: 'Create',
    props: ['meta', 'options'],
    data() {
        return {
            form: this.$inertia.form({
                name: '',
                description: '',
                goal: '',
                tag_ids: [],
                level_required: this.meta.default.level_required,
            }),
        };
    },
    methods: {
        submit() {
            this.form.post(this.meta.links.store);
        },
    },
};
</script>
